import history from 'State/history';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { clientPaths } from 'Consts/Strings';

const RedirectToDashboard = () => {
  useComponentDidMount(() => {
    const url = new URL(window.location.href);
    url.pathname = clientPaths.dashboard;

    history.replace(url.pathname + url.search + url.hash);
  });

  return null;
};

export default RedirectToDashboard;
